import React, { useReducer } from 'react';
import AppContext from 'contexts/AppContext';
import { settings } from 'config';
import { getColor, getItemFromStore } from 'helpers/utils';
import { configReducer } from 'reducers/configReducer';
import useToggleStyle from 'hooks/useToggleStyle';
import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);

const AppContextProvider = props => {
  const configState = {
    isFluid: getItemFromStore('isFluid', settings.isFluid),
    isRTL: getItemFromStore('isRTL', settings.isRTL),
    isDark: getItemFromStore('isDark', settings.isDark)
  };

  const [config, configDispatch] = useReducer(configReducer, configState);

  const { isLoaded } = useToggleStyle(
    config.isRTL,
    config.isDark,
    configDispatch
  );

  const setConfig = (key, value) => {
    configDispatch({
      type: 'SET_CONFIG',
      payload: {
        key,
        value,
        setInStore: ['isFluid', 'isRTL', 'isDark'].includes(key)
      }
    });
  };

  if (!isLoaded) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: config.isDark ? getColor('dark') : getColor('light')
        }}
      />
    );
  }

  return (
    <AppContext.Provider value={{ config, setConfig, configDispatch }}>
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
